import { ref, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'
import  axios  from 'axios'
import { API_URL } from '@/utils/constans.js'

export const useSettingsStore = defineStore('settings', () => {
	const settings = ref({})
	
	const statusStockActive = computed(() => settings.value?.status === "active"); // активный
	const statusStockFuture = computed(() => settings.value?.status === "future"); // еще не начался
	const statusStockPast = computed(() => settings.value?.status === "past"); // прошел
	const loaderActive = ref(false);
	const isPageLoaded = ref(false);
	const widthWindow = ref(window.innerWidth);
    const heightWindow = ref(window.innerHeight);

	const mainSettings = async() => {
		try{
			const response = await axios.get(`${API_URL}/api/main/settings`);
			settings.value = response.data;
		} catch(error) {
			console.log('error:',error);
		}
	}

	const getFaq = async() => {
		try {
			const { data } = await axios.get(`${API_URL}/api/feedback/faq?limit=1000`);
			return data.results;
		} catch(error) {
			console.log('getFaq:',error);
		}
	}

	const updateWidthWindow = () => { 
        widthWindow.value = window.innerWidth;
        heightWindow.value = window.innerHeight; 
    };

	const pageLoaded = () => {
        setTimeout(() => isPageLoaded.value = true, 1000);
    };

	onMounted( async () => {
		window.addEventListener('resize', updateWidthWindow);
		if (document.readyState === "complete") {
			pageLoaded();
		} else {
			window.onload = () => pageLoaded();
		}
		
	})
	
	return {
		mainSettings,
		getFaq,
		
		settings,		
		loaderActive,
		widthWindow,
		heightWindow,
		statusStockActive,
		statusStockFuture,
		statusStockPast
	}
})
